import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { fetcher } from "../client";
import { uploadFileV2, uploadFormFile } from "../actions/files";

export default function useFileUpload(options) {
  const { t } = useTranslation();
  const { mutate: mutateUploadFile, ...uploadFileState } = useMutation(
    ({ file }) =>
      fetcher(
        options.isPublic
          ? uploadFormFile(options.formId, file)
          : uploadFileV2(file, options.onUploadProgress)
      ),
    {
      ...options,
      onError: (error) => {
        toast.error(t(`errors.${error.message}`, t("errors.GeneralError")));
        // eslint-disable-next-line no-unused-expressions
        options?.onError?.(error);
      },
    }
  );

  const chooseFileAndUploadFile = (data, options = {}) => {
    const eleInput = document.createElement("input");
    eleInput.type = "file";
    eleInput.style.display = "none";
    eleInput.accept = options.accept ?? "application/pdf";
    eleInput.onchange = (e) => {
      const file = e.target.files[0];

      if (file) {
        mutateUploadFile({ ...data, file }, options);
      }
    };
    eleInput.click();
  };

  return {
    uploadFileState,
    uploadFile: mutateUploadFile,
    chooseFileAndUploadFile,
  };
}
